import React, { Component } from 'react';
import { CssBaseline, Grid, withStyles, Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DownloadLink from 'react-download-link';
const moment = require('moment');

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: '#1f1f1f',
    border: 'none',
    padding: '8px 16px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
  body: {
    border: 'none',
    fontSize: 14,
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',

    [theme.breakpoints.down('sm')]: {
      // padding: "8px 0",
      fontSize: '13px',
    },
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {},
}))(TableRow);

const styles = (theme) => ({
  table: {
    border: 'none',
    borderTop: `3px solid ${theme.palette.primary.main}`,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  evtInfoRowWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  evtInfoRowMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'table-row',
    },
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
});

class EvtNotiDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      isIE: /Trident/gi.test(navigator.userAgent) ? true : false,
    };
  }

  sendState = (event) => {
    // event.preventDefault();
    this.props.changeState('list');
  };

  ieDownload(url) {
    //iframe으로 하기
    let f = document.createElement('iframe');
    document.body.appendChild(f);

    f.src = url;
    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
  }

  download(imageUrl) {
    // fake server request, getting the file url as response
    setTimeout(() => {
      const response = {
        file: imageUrl,
      };
      // server sent the url to the file!
      // now, let's download:
      window.open(response.file);
      // you could also do:
      // window.location.href = response.file;
    }, 100);
  }

  getDataFromURL = (url) =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        fetch(url, { Pragma: 'no-cache' })
          .then((response) => response.blob())
          .then((data) => {
            console.log(data);
            resolve(data);
          });
      });
    });

  render() {
    const { classes, selectedItem } = this.props;
    // console.log(this.props.selectedItem);

    const mapToComponent = (datas) => {
      datas = selectedItem.files;
      // console.log(datas);
      return datas.map((dlItems, i) => {
        //console.log(dlItems);

        //let conv = dlItems.location.replace('https://s3.ap-northeast-2.amazonaws.com', '');
        //console.log(conv);
        return (
          <div key={i}>
            <div>
              {this.state.isIE ? (
                <span
                  id={'ieDownloadTag'}
                  style={{ cursor: 'pointer', textDecoration: 'underline', color: '#0000EE' }}
                  onClick={() => this.ieDownload(dlItems.location)}
                >
                  {dlItems.name}
                </span>
              ) : (
                <DownloadLink
                  label={`${dlItems.name}`}
                  filename={`${dlItems.name}`}
                  exportFile={() => Promise.resolve(this.getDataFromURL(dlItems.location))}
                />
              )}
            </div>
          </div>
        );
      });
    };

    return (
      <React.Fragment>
        <CssBaseline />
        <Grid container style={{ minHeight: '60vh' }}>
          <TableContainer component={Paper} style={{ boxShadow: 'none', borderRadius: 0, marginBottom: '1em' }}>
            <Table className={classes.table}>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    component="th"
                    width="20%"
                    align="center"
                    style={{
                      backgroundColor: 'rgba(29, 27, 84, 0.3)',
                      fontWeight: 'bold',
                    }}
                  >
                    제목
                  </StyledTableCell>
                  <StyledTableCell component="th" width="80%" align="left" colSpan={3}>
                    {selectedItem.title}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell
                    component="th"
                    width="20%"
                    align="center"
                    style={{
                      backgroundColor: 'rgba(29, 27, 84, 0.3)',
                      fontWeight: 'bold',
                    }}
                  >
                    등록일
                  </StyledTableCell>
                  <StyledTableCell component="th" width="30%" align="left">
                    {moment(Number(selectedItem.createdAt)).format('YYYY-MM-DD')}
                  </StyledTableCell>
                </StyledTableRow>
                {/* API 완성 후 등록일 작성일 따로 표기, 조회수 있을 경우 주석해제 */}
                {/* <StyledTableRow className={classes.evtInfoRowWeb}>
                  <StyledTableCell
                    component="th"
                    width="20%"
                    align="center"
                    style={{
                      backgroundColor: 'rgba(29, 27, 84, 0.3)',
                      fontWeight: 'bold',
                    }}
                  >
                    등록일
                  </StyledTableCell>
                  <StyledTableCell component="th" width="30%" align="left">
                    {moment(Number(selectedItem.createdAt)).format('YYYY-MM-DD')}
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    width="20%"
                    align="center"
                    style={{
                      backgroundColor: 'rgba(29, 27, 84, 0.3)',
                      fontWeight: 'bold',
                    }}
                  >
                    조회수
                  </StyledTableCell>
                  <StyledTableCell component="th" width="30%" align="left">
                    {selectedItem.viewCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  </StyledTableCell>
                </StyledTableRow> */}
              </TableHead>
              <TableBody>
                <TableRow>
                  <StyledTableCell colSpan={4}>
                    <Grid container style={{ minHeight: '40vh' }}>
                      <div dangerouslySetInnerHTML={{ __html: selectedItem.content }} />
                    </Grid>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell
                    component="th"
                    width="20%"
                    align="center"
                    style={{
                      backgroundColor: 'rgba(29, 27, 84, 0.3)',
                      fontWeight: 'bold',
                    }}
                  >
                    다운로드
                  </StyledTableCell>
                  <StyledTableCell component="th" width="80%" align="left" colSpan={3}>
                    {selectedItem.files && mapToComponent(selectedItem.files)}
                  </StyledTableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Grid item xs={12}>
            <Grid container justify="flex-end">
              <Button className={classes.button} onClick={this.sendState}>
                목록
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(EvtNotiDetail);
